export enum EVasCategory {
    'antiviruses' = '6.1',
    'onlineCinemas' = '6.2',
    'watchControl' =  '6.4',
    'watchEverywhere' = '6.12',
    'games' = '6.13',
    'partnerService' = '6.6',
    'multimedia' = '6.21',
    'speedBonuses' = '3',
    'bundles' = '11',
    'tv' = '1',
    'service' = '5',
}

export enum EVasContentType {
    'antiviruses' = 1,
    'onlineCinemas' = 2,
    'games' = 13,
    'partnerService' = 6,
    'multimedia' = 21,
}
